import { useEffect, useState, type ReactNode } from "react";

/**
 * /join-only: expands its children in (height + opacity, ~200ms ease-out) when
 * it mounts, via a grid-rows 0fr -> 1fr transition so the content above never
 * moves. `motion-reduce` drops the transition. Mount it only while the content
 * should show; it does not animate out.
 */
export function JoinReveal({
  children,
  testId,
}: {
  children: ReactNode;
  testId?: string;
}) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => setShown(true));
    return () => window.cancelAnimationFrame(frame);
  }, []);
  return (
    <div
      data-testid={testId}
      data-state={shown ? "open" : "closed"}
      className={`grid transition-[grid-template-rows,opacity] duration-[var(--sill-duration-normal)] ease-[var(--sill-ease)] motion-reduce:transition-none ${
        shown ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
      }`}
    >
      <div className="min-h-0 overflow-hidden">{children}</div>
    </div>
  );
}
